module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAYAAACoPemuAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEUSURBVHgB7ZgxCsIwFIb/pB0cPUK9gUfwGm66CE7iSYougksEB4+hN/AI9hiCaE2Kig21fa8UzPA+aAN/yutXXpKhQKCousnV9nCxQ+LF2WI2HqAFnHoa9STEjEpCzBrFCuwXKXehIyj1YndLjenjGg9BJN2YBB2SbvYjPyvE9K13RkRvkY56F3SIjuIjqsTw6nOucPqeVDlGVYVyu2DRAvVjPVW9t+iz3S25G/2+v3OftuuNWs8917T4M2JGJSNmn1ZW0va86qIe6bj4B8GKlVq53h4MAsDtkNgLJgiEktjjjikCQEcwJbHlfLxDANhzzMiu5CJiXESMi4hxETEuIsZFxLiIGBcR4yJiXIIVK/3tCYknUWxGKp40QZoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/date-icon.png
// module id = 660
// module chunks = 1